// ------------------------------
// UI - RENDER SPECIFIC CONTENT
// ------------------------------

goog.provide('el8.render.content');

goog.require('el8.data.base');
goog.require('el8.ptdata.model.noteItem');
goog.require('el8.appservice.search');
goog.require('el8.appchart.dialog.selectFile');

el8.render.content = (function() {

    function renderMergeIntoReport( report ) {

        var message = 'NOTE: This report will be merged with the selected report and will no longer display separately.  ' +
                      'Be aware that any tags and report notes associated with this report will NOT BE MERGED into the destination report.';
        if( !report.isSignedOff() ) {
            message += '  The destination report will be marked as *NEW*.';
        }

        el8.appchart.dialog.selectFile.show({ 
            reportId: report.getId(),
            title: 'Select existing report to merge this report INTO',
            message: message,
            btnText: 'Merge Report with Selected',
            instructions: report.getNoteSummary() + ' will be merged into the selected report.',
            selectFn: function( fileIds, callbackFn ) {
                var fileId = fileIds[0]; // argument is an array, but only one file can be selected
                report.saveMergeReport( fileId, callbackFn );
            }
        });
    }

    function renderPreviousReportAsPartial( report ) {
        el8.appchart.dialog.selectFile.show({
            reportId: report.getId(),
            title: 'Select existing report to mark as \"partial\"',
            message: 'NOTE: Partial reports will be archived and be replaced by the Final report.  The partial report will no longer be ' +
                     'displayed in this patient\'s chart. All related notes and activity associated with the partial report will be linked ' + 
                     'to the Final report.  If necessary, patient chart will reload to reflect the changes made.',
            btnText: 'Mark Report as Partial',
            instructions: 'Selected report will be replaced by: ' + report.getNoteSummary(),
            selectFn: function( fileIds, callbackFn ) {
                var fileId = fileIds[0]; // argument is an array, but only one file can be selected
                report.savePreviousAsPartial( fileId, callbackFn );
            }
        });
    }

	return {
        renderMergeIntoReport: renderMergeIntoReport,
        renderPreviousReportAsPartial: renderPreviousReportAsPartial
	};
})();
